import { render } from "./StatisticalSelect.vue?vue&type=template&id=257c50ea&scoped=true"
import script from "./StatisticalSelect.vue?vue&type=script&lang=js"
export * from "./StatisticalSelect.vue?vue&type=script&lang=js"

import "./StatisticalSelect.vue?vue&type=style&index=0&id=257c50ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257c50ea"]])

export default __exports__